import { format } from "date-fns";
const toTimeString = (seconds) => {
  if (!seconds) seconds = 0;
  return format(new Date(seconds * 1000), "m:ss");
};

export default toTimeString;
